var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"align":"center"}},[(_vm.img)?_c('v-col',{staticClass:"text-right",attrs:{"cols":"auto"}},[_c('img',{staticClass:"ml-1",attrs:{"height":"32","src":_vm.img}})]):_vm._e(),_vm._v(" "),_c('v-col',{staticClass:"font-weight-medium subtitle-1"},[_vm._v("\n    "+_vm._s(_vm.section.label)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }